"use strict";

var app = angular.module('rmFormBuilder');

app.factory('FormBuilder', require('./formbuilder.js'));